export default (username) =>
`<div id="header">
	<span class="sial-header-brand">
		<img src="img/logo_h1.png">
		<img src="img/logo_h2.png">
	</span>
	<ul class="menu">
			<li>Organização
				<ul>
					<li hash="#customers">Clientes</li>
					<li hash="#devices">Dispositivos</li>
					<li hash="#input-docks">Docas&nbsp;Entrada</li>
					<li hash="#companies">Empresas</li>
					<li hash="#suppliers">Fornecedores</li>
					<li hash="#customer-routes">Rotas</li>
					<li hash="#carriers">Transportadores</li>
				</ul>
			</li>
			<li>Catálogo
				<ul>
					<li hash="#categories">Categorias</li>
					<li hash="#classes">Classes</li>
					<li hash="#product-packagings">Embalagens&nbsp;de&nbsp;Produto</li>
					<li hash="#manufacturers">Fabricantes</li>
					<li hash="#input-cancel-reasons">Motivos&nbsp;Cancelamento&nbsp;Entrada</li>
					<li hash="#stock-block-kinds">Naturezas&nbsp;de&nbsp;Bloqueio</li>
					<li hash="#products">Produtos&nbsp;e&nbsp;Classificações</li>
					<li hash="#programs">Programas</li>
					<li hash="#units">Unidades&nbsp;de&nbsp;Medida</li>
				</ul>
			</li>
			<li>Armazenamento
				<ul>
					<li hash="#warehouses">Armazéns</li>
					<li hash="#stocks">Estoques</li>
					<li hash="#stock-management">Gerenciamento&nbsp;de&nbsp;estoques</li>
					<li hash="#inventories">Inventários</li>
					<li hash="#locations">Posições</li>
					<li hash="#replenishments">Ressuprimentos</li>
					<li hash="#transactions">Transações</li>
				</ul>
			</li>
			<li>Movimentação
				<ul>
					<li hash="#input-dock-schedules">Agendamento&nbsp;de&nbsp;Docas</li>
					<li hash="#output-picking-boxes">Caixas&nbsp;de&nbsp;Picking</li>
					<li hash="#output-picking-countbacks">Countback&nbsp;Picking</li>
					<li hash="#picking-waves">Derrubada&nbsp;(ondas)</li>
					<li hash="#dock-expedition">Doca&nbsp;Expedição</li>
					<li hash="#inputs">Entradas</li>
					<li hash="#lots">Lotes</li>
					<li hash="#movements">Movimentações</li>
					<li hash="#input-orders">Pedidos&nbsp;de&nbsp;Entrada</li>
					<li hash="#output-orders">Pedidos&nbsp;de&nbsp;Saída</li>
					<li hash="#outputs">Saídas</li>
					<li hash="#receipt-types">Tipos&nbsp;de&nbsp;Recebimento</li>
				</ul>
			</li>
			<li>Comercial
				<ul>
					<li hash="#cfops">CFOPs</li>
					<li hash="#payment-terms">Condições&nbsp;de&nbsp;Pagamento</li>
					<li hash="#expiring-items">Itens&nbsp;a&nbsp;vencer</li>
					<li hash="#price-lists">Listas&nbsp;de&nbsp;Preços</li>
					<li hash="#invoices-billed-exclusive">Relatório&nbsp;Notas&nbsp;faturadas&nbsp;-&nbsp;Exclusivo</li>
				</ul>
			</li>
			<li>Faturamento
				<ul>
					<li hash="#nfe-emission-control">Controle&nbsp;emissão&nbsp;NF</li>
					<li hash="#invoice-lots">Lotes&nbsp;de&nbsp;Notas</li>
					<li hash="#invoices">Notas&nbsp;Fiscais</li>
				</ul>
			</li>
			<li>BI
				<ul>
					<li hash="#bi-stock-analytical">Analítico&nbsp;Estoque</li>
					<li hash="#bi-audit">Auditoria</li>
					<li hash="#bi-stock-blocks-descriptive">Bloqueios&nbsp;descritivo</li>
					<li hash="#bi-kardex">Kardex</li>
					<li hash="#bi-output-lines">Linhas&nbsp;de&nbsp;saída</li>
					<li hash="#bi-output-productivity">Produtividade&nbsp;por&nbsp;funcionário</li>
				</ul>
			</li>
			<li data-especial-root hidden>
				Especial
				<ul>
					<li data-especial-tenant="sessp" hidden>
						SESSP
						<ul>
							<li hash="#especial-sessp-faturas">Gestão&nbsp;de&nbsp;Faturas</li>
						</ul>
					</li>
				</ul>
			</li>
			<li>Sistema
				<ul>
					<!-- <li hash="#endpoints">Endpoints&nbsp;da&nbsp;API</li> -->
					<li hash="#logs">Auditoria&nbsp;de&nbsp;Eventos</li>
					<li hash="#import-center">Central&nbsp;de&nbsp;Importação</li>
					<li hash="#integration-events">Central&nbsp;de&nbsp;Integrações</li>
					<li hash="#groups">Grupos&nbsp;e&nbsp;Permissões</li>
					<li hash="#logout">Logout&nbsp;do&nbsp;Usuário</li>
					<li hash="#about">Sobre o Sistema</li>
					<li hash="#users">Usuários&nbsp;e&nbsp;Associações</li>
				</ul>
			</li>
	</ul>
	<div id="identification">
		Usuário: ${username}
	</div>
</div>
<div id="workarea">
</div>`;

